import { NgModule } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { WishlistApiRepository } from './infrastructure/api/wishlist.api.repository';
import { WishlistCommandsFacade } from './infrastructure/facades/commands/wishlist.commands.facade';
import { WishlistSharedQueriesFacade } from './infrastructure/facades/queries/shared.queries.facades';
import { WishlistQueriesFacade } from './infrastructure/facades/queries/wishlist.queries.facades';
import * as WishlistNotificationEffects from './infrastructure/notifications/wishlist-notification.effects';
import { WishlistEffects } from './infrastructure/state/wishlist.effects';
import { wishlistReducer } from './infrastructure/state/wishlist.reducer';

@NgModule({
    providers: [
        provideState({ name: 'wishlists', reducer: wishlistReducer }),
        provideEffects([WishlistEffects, WishlistNotificationEffects]),
        WishlistApiRepository,
        WishlistCommandsFacade,
        WishlistQueriesFacade,
        WishlistSharedQueriesFacade,
    ],
})

export class WishlistFeatureModule { }
